'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _userPayAgreements = require('./user-pay-agreements.html');

var _userPayAgreements2 = _interopRequireDefault(_userPayAgreements);

var _userPayAgreements3 = require('./user-pay-agreements.controller');

var _userPayAgreements4 = _interopRequireDefault(_userPayAgreements3);

require('./user-pay-agreements.styl');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var userPayAgreementsComponent = {
  restrict: 'E',
  bindings: {
    userId: '<'
  },
  template: _userPayAgreements2.default,
  controller: _userPayAgreements4.default,
  controllerAs: 'vm'
};

exports.default = userPayAgreementsComponent;


/** WEBPACK FOOTER **
 ** ./client/app/common/Components/user-pay-agreements/user-pay-agreements.component.js
 **/